import {assign} from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import moment from 'moment'
import {nextStep} from 'utils/step_utils'
import i18n from 'i18n/config'

const stepName  = 'productVariantsStep'

const setError = assign({error: i18n.t('validations:product_variants_fetch_error')})
const setProductVariant = assign({product_variant_id: (ctx, e) => {
  return e.variant.id
}})
const cleanError = assign({error: null})

const initProductVariants = assign({product_variants: (ctx, e) => {
  return e.data
}})

const fetchProductVariants = (ctx) => {
  return (
    new ApiFetcher({
      key: 'product_variants',
      endpoint: ctx.endpoints.product_variants
    }).call()
  )
}

const productVariantsState = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {
          '': [
            {
              target: 'fetchingProductVariants',
              actions: [cleanError, 'startSpinner']
            },
            {
              target: 'waitingProductVariantPick'
            }
          ],
        },
      },
      fetchingProductVariants: {
        invoke: {
          src: fetchProductVariants,
          onDone: {
            target: 'waitingProductVariantPick',
            actions: [initProductVariants, 'stopSpinner']
          },
          onError: {
            target: '#purchase.error',
            actions: [setError, 'stopSpinner', 'scrollToError']
          }
        }
      },
      waitingProductVariantPick: {
        onEntry: []
      }
    },
    on: {
      PRODUCT_VARIANT_SELECTION: [
        {
          target: nextStep(config, stepName) ? `#purchase.${nextStep(config, stepName)}` : '#purchase.reserving',
          actions: setProductVariant
        }
      ]
    }
  }
}

export default productVariantsState
